/* eslint-disable import/no-unresolved */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as Actions from "actions";
import { Container, Box } from "@mui/material";

// Import Swiper styles
import 'swiper/swiper.min.css';
import './UserShopsLatestSlider.scss'

import UserSellerShop from "components/elements/user/shops/UserSellerShop";
import MockProductBox from "components/elements/main/MockProductBox";
import CustomSectionCreator from "components/CustomSectionCreator";

import StoreIcon from "@mui/icons-material/Store";
import {isFeatureSupported} from "helpers/utils";
import FiberNewIcon from "@mui/icons-material/FiberNew";

const UserShopsLatestSlider = (props) => {

  const {
      latestshops, userMainAddStoreToFavlist, userMainGetLatestStoreList, isLoading, marketId, includeHeader
  } = props;
  const { shops } = latestshops;

    useEffect(() => {
        userMainGetLatestStoreList(marketId);
    }, []);

    const breakpoints = {
        300: {
            slidesPerView: 2.0,
            spaceBetween: 20,
        },
        340: {
            slidesPerView: 2.2,
            spaceBetween: 20,
        },
        380: {
            slidesPerView: 2.4,
            spaceBetween: 20,
        },
        420: {
            slidesPerView: 2.6,
            spaceBetween: 20,
        },
        480: {
            slidesPerView: 2.8,
            spaceBetween: 20,
        },
        640: {
            slidesPerView: 4,
            spaceBetween: 20,
        },
        768: {
            slidesPerView: 4,
            spaceBetween: 30,
        },
        1024: {
            slidesPerView: 5,
            spaceBetween: 20,
        },
    };

    const renderResults = () => (
        <Container>
            {includeHeader && <CustomSectionCreator icon={<FiberNewIcon sx={{ color: '#E53E3E', mr: 1 }} />} title={'New ' + process.env.REACT_APP_SHOP_TITLE}  seeLink="/shops/sort/new" seeMoreLinkTitle={isFeatureSupported("shopreels") ? "View more" : "View more"} seeMoreLink={isFeatureSupported("shopreels") ? "/shops/sort/new?ls=1" : "/shops/sort/new"} />}
            <swiper-container slides-per-view="1.8" space-between="4" free-mode="true" breakpoints={JSON.stringify(breakpoints)}>
                { shops.map((shop, index) => (
                    <swiper-slide key={index}>
                        <Box sx={{ width: 150 }}>
                        <UserSellerShop
                            shop={shop}
                            isDirect={true}
                            linkArrow={isFeatureSupported("shopreels") ? "/shops/sort/new?ls=1&li=" + index : ""}
                            linkMain={"/shops/sort/new?ls=2&li=" + index}
                            onAddToFavlistClicked={() => userMainAddStoreToFavlist(shop)}
                            key={`${index + 1}`}
                        />
                        </Box>
                    </swiper-slide>
                ))}
            </swiper-container>
        </Container>
    );

  return (
<>
      {isLoading ? <MockProductBox />
              : shops.length > 0
                  ? renderResults()
                  : ""}

</>

  );
};

UserShopsLatestSlider.propTypes = {
    latestshops: PropTypes.objectOf(PropTypes.any).isRequired,
    userMainGetPopularStoreList: PropTypes.func.isRequired,
    userMainAddStoreToFavlist: PropTypes.func.isRequired,
};

// Mapping Props and State.
const userShopsLatestSlider = connect(
  ({ userMainShops, bootupInfo }) => ({
    bootupInfo,
    reqStatus: userMainShops.reqStatus,
    isLoading: userMainShops.isLoading,
    serviceError: userMainShops.serviceError,
      latestshops: userMainShops.latestshops,
  }),
  (dispatch) => bindActionCreators({ ...Actions }, dispatch),
)(UserShopsLatestSlider);

export { userShopsLatestSlider as default };
